'use client'
import React from 'react'

export interface SubNavigationWrapperProps {
    children: React.ReactNode
}

export const SubNavigationWrapper = ({ children }: SubNavigationWrapperProps) => {
    return (
        <div className="main-navigation__sub-navigation-wrapper absolute top-full left-1/2 transform -translate-x-1/2">
            <div className="bg-shade-100 border border-shade-200 shadow-drop-sm mt-[2px]">{children}</div>
        </div>
    )
}
